import React, { useEffect, useRef, useState } from 'react';
import './roomGuestSelector.css';
import { ReactComponent as DropdownDownArrow } from '../../assets/icons/dropdownArrowDown.svg';
import { ReactComponent as DropdownUpArrow } from '../../assets/icons/dropdownArrowUp.svg';
import { toast } from 'react-toastify';

const MAX_GUESTS = 3;
const MAX_ROOMS = 4;

const RoomGuestSelector = ({ rooms, peoples, setData }) => {
    const [isOpen, setIsOpen] = useState(false);
    const maxAllowed = rooms * 3;
    const [editRoomId, setEditRoomId] = useState(1);
    const popupRef = useRef(null);

    // const handleIncrement = (roomIndex) => {
    //     const updated = rooms.map((roomItem, index) =>
    //         index === roomIndex ? { ...roomItem, adults: Math.min(roomItem.adults + 1, MAX_GUESTS) } : roomItem
    //     );
    //     setRooms(updated);
    // };

    // const handleDecrement = (roomIndex) => {
    //     const updated = rooms.map((roomItem, index) =>
    //         index === roomIndex ? { ...roomItem, adults: Math.max(roomItem.adults - 1, 1) } : roomItem
    //     );
    //     setRooms(updated);
    // };

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    // const handleAddRoom = () => {
    //     if (rooms.length < MAX_ROOMS) {
    //         const newId = rooms.length + 1;
    //         const updated = [...rooms, { id: newId, adults: 1 }];
    //         setRooms(updated);
    //         setEditRoomId(newId);
    //     }
    // };

    // const handleRemoveRoom = () => {
    //     if (rooms.length === 1) return;
    //     const updated = rooms.slice(0, -1);
    //     setRooms(updated);
    //     setEditRoomId(updated.length > 0 ? updated[updated.length - 1].id : null);
    // };

    useEffect(() => {
        const handleClickOutsidePopup = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutsidePopup);
        return () => {
            document.removeEventListener('mousedown', handleClickOutsidePopup);
        };
    }, []);

    // const totalGuests = rooms?.reduce((acc, roomItem) => acc + roomItem.adults, 0);

    const increaseAdults = () => {
        if (peoples >= rooms * 3) {
            toast.error('Increase room to add more people');
            return;
        }

        setData({ people: peoples + 1 });
    };
    const decreaseAdults = () => {
        if (peoples <= 1) return;
        setData({ people: peoples - 1 });
    };

    const increaseRooms = () => {
        if (rooms >= peoples) {
            toast.error('Add more adults to increase rooms');
            return;
        }
        setData({ rooms: rooms + 1 });
    };

    const decreaseRooms = () => {
        const minRooms = Math.ceil(peoples / 3);

        if (rooms <= minRooms) {
            return;
        }

        setData({ rooms: rooms - 1 });
    };

    console.log(peoples);
    return (
        <div ref={popupRef} className='roomGuestSelector-container'>
            <div className='roomGuestSelector-container-div' onClick={handleToggle}>
                <div className='roomGuest-label-container'>
                    <label className='roomGuest-label'>{`Rooms(${rooms}) & Guest(${peoples})`}</label>
                </div>
                <div className='dropdown-arrow-icon'>{isOpen ? <DropdownUpArrow /> : <DropdownDownArrow />}</div>
            </div>

            {isOpen && (
                <div className='popup-container'>
                    {/* <header className='popup-header'>
                        <p>Total {MAX_GUESTS} adults allowed in a room</p>
                    </header> */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <span className='textDivMain'>Select Rooms and Guests</span>
                        <span
                            onClick={() => {
                                setIsOpen(false);
                            }}
                        >
                            X
                        </span>
                    </div>
                    <main className='popup-content'>
                        {/* <p className='popup-main-header'>Room {item.id}</p>

                            {editRoomId === item.id ? (
                                <div style={{ display: 'flex' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <p className='popup-main-text'>
                                            <span className='popup-span-text'>Adults</span> - Above 12 Years
                                        </p>
                                        <div className='counter-card'>
                                            <div
                                                onClick={() => handleDecrement(index)}
                                                style={{ fontSize: 25 }}
                                                className='decrement-btn'
                                            >
                                                -
                                            </div>
                                            <span style={{ fontSize: 18, marginTop: 5 }} className='counter-text-value'>
                                                {item.adults}
                                            </span>
                                            <div
                                                onClick={() => handleIncrement(index)}
                                                style={{ fontSize: 25 }}
                                                className='increment-btn'
                                            >
                                                +
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='room-actions'
                                        style={{
                                            justifyContent: 'space-around',
                                            flexDirection: 'column',
                                            gap: '5px'
                                        }}
                                    >
                                        <span className='remove-btn-text' onClick={() => setEditRoomId(null)}>
                                            Done
                                        </span>
                                        {item.id !== 1 && (
                                            <span className='remove-btn-text' onClick={() => handleRemoveRoom(item.id)}>
                                                Remove
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <p className='popup-main-text'>
                                        <span className='popup-span-text'>Adults</span>: {item.adults}
                                    </p>
                                    <div className='room-actions'>
                                        <span className='remove-btn-text' onClick={() => setEditRoomId(item.id)}>
                                            EDIT
                                        </span>
                                        {item.id !== 1 && (
                                            <span className='remove-btn-text' onClick={() => handleRemoveRoom(item.id)}>
                                                REMOVE
                                            </span>
                                        )}
                                    </div>
                                </>
                            )}
                            <hr style={{ marginTop: 8 }} /> */}
                        <div>
                            <div className='textDiv'>
                                <span className='textDivMain'>Room</span>
                                <span className='textDivSub'>Number of rooms</span>
                            </div>
                            <div className='countDiv'>
                                <span className='buttonDec' onClick={decreaseRooms}>
                                    -
                                </span>
                                <span className='countText'>{rooms}</span>
                                <span className='buttonInc' onClick={increaseRooms}>
                                    +
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className='textDiv'>
                                <span className='textDivMain'>Adults</span>
                                <span className='textDivSub'>Age above 5 years</span>
                            </div>
                            <div className='countDiv'>
                                <span className='buttonDec' onClick={decreaseAdults}>
                                    -
                                </span>
                                <span className='countText'>{peoples}</span>
                                <span className='buttonInc' onClick={increaseAdults}>
                                    +
                                </span>
                            </div>
                        </div>
                        {/* <div>
                                <div className='textDiv'>
                                    <span className='textDivMain'>Children</span>
                                    <span className='textDivSub'>Ages 2-12</span>
                                </div>
                                <div className='countDiv'>
                                    <span className='buttonDec'>-</span>
                                    <span className='countText'>1</span>
                                    <span className='buttonInc'>+</span>
                                </div>
                            </div> */}
                    </main>

                    {/* <div className='add-btn-container'>
                        {rooms.length < MAX_ROOMS && (
                            <button onClick={handleAddRoom} className='add-btn'>
                                ADD ANOTHER ROOM +
                            </button>
                        )}
                        <button onClick={() => setIsOpen(false)} className='apply-btn'>
                            Apply
                        </button>
                    </div> */}
                    <div
                        className='doneBtn'
                        onClick={() => {
                            setIsOpen(false);
                        }}
                    >
                        Done
                    </div>
                </div>
            )}
        </div>
    );
};

export default RoomGuestSelector;
